const blogData = [
  {
    id: 1,
    img: "/assets/images/blog/post/blog-post-01.png",
    tag: "Company",
    author: "Industrie",
    date: "June 12, 2023",
    title: "Factories technologies in interactive and plants",
    // description: "Industry’s standard dummy text ever since...",
    description:
      "Industry’s standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. At vero eos et accusamus et iusto odio.",
  },
  {
    id: 2,
    img: "/assets/images/blog/post/blog-post-02.png",
    tag: "Oil Factory",
    author: "Industrie",
    date: "June 12, 2023",
    title: "Factories technologies in interactive and plants",
    description:
      "Industry’s standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. At vero eos et accusamus et iusto odio.",
  },
  {
    id: 3,
    img: "/assets/images/blog/post/blog-post-03.png",
    tag: "Manufacture",
    author: "Industrie",
    date: "June 12, 2023",
    title: "Factories technologies in interactive and plants",
    description:
      "Industry’s standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. At vero eos et accusamus et iusto odio.",
  },
  {
    id: 4,
    img: "/assets/images/blog/post/blog-post-04.png",
    tag: "Industry",
    author: "Industrie",
    date: "June 12, 2023",
    title: "Building resilient supply for industries and factorie",
    description:
      "Industry’s standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. At vero eos et accusamus et iusto odio.",
  },
  {
    id: 5,
    img: "/assets/images/blog/post/blog-post-01.png",
    tag: "Manufacture",
    author: "Industrie",
    date: "June 12, 2023",
    title: "Construction of Link new high tech plant in Washington",
    description:
      "Industry’s standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. At vero eos et accusamus et iusto odio.",
  },
  {
    id: 6,
    img: "/assets/images/blog/post/blog-post-02.png",
    tag: "Oil Factory",
    author: "Industrie",
    date: "June 12, 2023",
    title: "Interactive technologies in factories and plants",
    description:
      "Industry’s standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. At vero eos et accusamus et iusto odio.",
  },
];

export default blogData;
